(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-logo-section"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const dateContainer = document.querySelector('.date-time-container');
  if (!dateContainer) return;

  const dateEl = dateContainer.querySelector('.date');
  const timeEl = dateContainer.querySelector('.time');

  function updateTime() {
    const now = new Date();
    
    // Local date formatting
    const dateOptions = { weekday: 'short', month: 'short', day: 'numeric' };
    const newDate = now.toLocaleDateString(undefined, dateOptions);

    // Local time formatting (includes seconds to see frequent updates)
    const timeOptions = { hour: '2-digit', minute: '2-digit', second: '2-digit' };
    const newTime = now.toLocaleTimeString(undefined, timeOptions);

    // Update Date and Pulse if changed
    if (dateEl.innerText !== newDate) {
      dateEl.innerText = newDate;
      triggerPulse(dateEl);
    }

    // Update Time and Pulse
    if (timeEl.innerText !== newTime) {
      timeEl.innerText = newTime;
      triggerPulse(timeEl);
    }
  }

  function triggerPulse(element) {
    // Remove class to reset animation
    element.classList.remove('time-pulse-anim');
    // Trigger reflow to restart animation
    void element.offsetWidth;
    // Add class back
    element.classList.add('time-pulse-anim');
  }

  // Run immediately and then every second
  updateTime();
  setInterval(updateTime, 1000);
});

  } catch(e) { console.error(e); }
})();
})();
